import React, { useMemo, useState, useEffect, useCallback } from 'react'
import { MainHeader } from 'application/presentation/common/Header'
import FormContainer from 'application/presentation/common/FormContainer/FormContainer'
import { Button, CodeInput } from 'application/presentation/common/uiComponents'
import { useLocation, useNavigate } from 'react-router'

import { useAuthorization } from './useAuthorization'
import s from './AuthPage.module.scss'

const RegistrationPage = () => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const [code, setCode] = useState<string>('')

  const phone = useMemo(() => {
    const params = new URLSearchParams(search)
    const p = params.get('phone')
    return p || ''
  }, [search])

  const { checkCode, btnHidden, checkIsLoading } = useAuthorization({})

  const onCheckClickHandler = useCallback(() => {
    checkCode(phone, code, () => {
      navigate(`/new_password?phone=${phone}`, { replace: true })
    })
  }, [checkCode, code, navigate, phone])

  // useEffect(() => {
  //   if (code && phone) {
  //     checkCode(phone, code, () => {
  //       navigate(`/new_password?phone=${phone}`, { replace: true })
  //     })
  //   }
  // }, [checkCode, code, phone, navigate])

  return (
    <>
      <MainHeader />
      <div className={s.container}>
        <FormContainer title="Вам отправлен смс код" subtitle="Введите его сюда">
          <CodeInput onChange={setCode} phone={phone} isOneTimeCode />
          {!btnHidden && (
            <Button
              color="fiol"
              type="submit"
              stopEvents
              text={'Далее'}
              onClick={onCheckClickHandler}
              isLoading={checkIsLoading}
              containerClassName={s.btn}
            />
          )}
        </FormContainer>
      </div>
    </>
  )
}

export default React.memo(RegistrationPage)
